var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarrelAssignmentWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.159 10.2121L58.3656 48.7729C59.9221 51.4896 57.9111 54.8438 54.7068 54.8438H10.2936C7.08926 54.8438 5.07832 51.4896 6.63476 48.7729L28.8414 10.2121C30.441 7.4293 34.5594 7.4293 36.159 10.2121Z",
    stroke: "#664D03",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 36.5625V26.4062",
    stroke: "#664D03",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 48.75C34.1827 48.75 35.5469 47.3859 35.5469 45.7031C35.5469 44.0204 34.1827 42.6562 32.5 42.6562C30.8173 42.6562 29.4531 44.0204 29.4531 45.7031C29.4531 47.3859 30.8173 48.75 32.5 48.75Z",
    fill: "#664D03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrelAssignmentWarningIcon);
export default __webpack_public_path__ + "static/media/BarrelAssignmentWarningIcon.f5574f931853d5aff835e34d9d662482.svg";
export { ForwardRef as ReactComponent };